export interface OperationLoadingState {
	operationName: string;
	loadingState: "idle" | "loading" | "loaded" | "error";
	error?: string;
}

export interface OperationLockState {
	group?: string;
	reference: string;
	userId: string;
	userFullName: string;
	lockedAt: string;
	lockExpiration: string;
}

export interface OperationsSlice {
	loadingState: OperationLoadingState[];
	lockState: OperationLockState[];
	lastCreatedProcessBusinessKey: string | undefined;
}

export const DOC_LOCK_OPERATION: string = "DocumentLockOperation";
